import React from 'react';
import { getProficiencyConfig } from '../utils/skillHelpers';

const SkillBrick = ({ playSkill, handleFocus }) => {
  const config = getProficiencyConfig(playSkill.proficiency);

  return (
    <div
      className={`
        ${config.bg} ${config.hover} ${config.ring} ${config.glow}
        border-2 border-white/20 rounded-2xl p-4 my-3 
        cursor-pointer transition-all duration-300 ease-out
        transform hover:scale-105 hover:shadow-xl
        focus:outline-none focus:ring-2 focus:ring-offset-2
        active:scale-95 select-none backdrop-blur-sm
        shadow-lg border-b-4 border-b-black/20
      `}
      onClick={() => handleFocus(playSkill)}
      onKeyDown={(e) => {
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault();
          handleFocus(playSkill);
        }
      }}
      tabIndex={0}
      role="button"
      aria-label={`${playSkill.name} skill - ${config.label} level`}
    >
      <div className="flex items-center justify-between">
        <div className="flex items-center gap-3">
          <span className="text-2xl">{config.emoji}</span>
          <h2 className="text-lg font-bold text-white drop-shadow-lg">
            {playSkill.name}
          </h2>
        </div>
        <div className="flex flex-col items-end">
          <span className="text-base font-semibold text-white/90 bg-black/20 px-2 py-1 rounded-full">
            {config.label}
          </span>
          {playSkill.attempts > 0 && (
            <span className="text-sm text-white/80 mt-1">
              {playSkill.attempts} attempts
            </span>
          )}
        </div>
      </div>
      
      <div className="flex mt-3 space-x-1">
        {[0, 1, 2].map((level) => (
          <div
            key={level}
            className={`h-2 w-full rounded-full transition-all duration-300 ${
              level <= playSkill.proficiency 
                ? 'bg-white/40 shadow-sm' 
                : 'bg-white/10'
            }`}
          />
        ))}
      </div>
    </div>
  );
};

export default SkillBrick;